import { convertArrayToMap } from './convert-array-to-map';

/**
 * Note: adding a value to this object will require you to add an entry to
 * the `contact-activity-item-configuration`. This object is used to configure
 * displaying the activity in the contact activity feeds. It is okay to simply
 * add it as `undefined` there if it shouldn't be displayed, or we are rolling out
 * a feature over time.
 */
export const ACTIVITY_TYPES = Object.freeze({
  COMMENT: 'comment',
  STATUS: 'status',
  CONTACT: 'contact',
  MESSAGE: 'message',
  FINALIZING_HIRE_STEP: 'finalizing_hire_step',
  UPDATE: 'update',
  CALL: 'call',
  SHARE: 'share',
  EMP_MANUALLY_ADDED: 'emp_manually_added',
  EMP_QUIT_FIRED: 'emp_quit_fired',
  ADD_FILE: 'add_file',
  REMOVE_FILE: 'remove_file',
});

export type ContactActivityValueType = ValueOf<typeof ACTIVITY_TYPES>;
export const ACTIVITY_TYPE_VALUES = convertArrayToMap(Object.values(ACTIVITY_TYPES), (v) => v);
